// PUBLIC TOP JOBS ********************************************************************
// pathname: /v2/jobs
// **************************************************************************************
import { fetcherSwrBase } from '@utils/data-fetching/fetcher';


// Interface
// ********************************************
export type PublicTopJobsResponse = ApiSchema<'CursorJobResult'>;


/**
 * @description Fetch the top public jobs for unauthenticated visitors.
 *
 * Backed by `GET /v2/jobs?limit=N`, called exactly like the public job-list page
 * (`/locuri-de-munca`): default credentials, no `credentials: 'omit'`. Omitting cookies
 * sends a request with no `NEXT_LOCALE`, which the locale middleware answers with a 301 to
 * `/ro/api/proxy/...` — a path the proxy route does not serve (404), so the slot rendered
 * empty. Anonymous visitors have no session anyway, so the proxy forwards this anonymously.
 *
 * @param limit - number of jobs to fetch; default 3.
 * @param locale - locale for the Accept-Language header; default 'ro'.
 */
export const fetchPublicTopJobs = (limit = 3, locale = 'ro'): Promise<PublicTopJobsResponse> => (
  fetcherSwrBase<PublicTopJobsResponse>(
    `/v2/jobs?limit=${limit}`,
    locale,
    {},
  )
);
